export default function onlyChangedValues<O extends { [key: string]: unknown }, N extends { [key: string]: unknown }>(
	oldData: O,
	newData: N
): Partial<N> {
	return Object.entries(newData).reduce(
		(changedData, [key, value]) => (newData[key] !== oldData[key] ? { ...changedData, [key]: value } : changedData),
		{}
	)
}
